const SelfAppraisal = () => import("./views/MySelfAppraisal.vue");
const ViewSelfAppraisal = () => import("./views/ViewSelfAppraisal.vue");

const AllAppraisalApproval = () => import("./views/AllAppraisalApproval.vue");

const AllMyAppraisal = () => import("./views/AllMyAppraisal.vue");
const ViewAppraisal = () => import("./views/ViewSelfAppraisal.vue");

export default [
  {
    path: "self-appraisal",
    component: SelfAppraisal,
  },
  {
    path: "view-self-appraisal/:id",
    component: ViewSelfAppraisal,
  },
  {
    path: "appraisal-approvals",
    component: AllAppraisalApproval,
  },
  {
    path: "appraisal",
    component: AllMyAppraisal,
  },
  {
    path: "view-appraisal/:id",
    component: ViewAppraisal,
  },
];
